module.exports = __webpack_public_path__ + "static/media/image_collage.ec13e197.png";